import { render, staticRenderFns } from "./ISAPAdmissions.vue?vue&type=template&id=36f88a85&scoped=true&"
import script from "./ISAPAdmissions.vue?vue&type=script&lang=js&"
export * from "./ISAPAdmissions.vue?vue&type=script&lang=js&"
import style0 from "./ISAPAdmissions.vue?vue&type=style&index=0&id=36f88a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f88a85",
  null
  
)

export default component.exports